import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import actionCreator from "../../../redux/action/actionCreator";

// core-components
import Toast from "../../../components/MessageToast";
import CreateForm from "../../components/forms/Form";
import { CREATE_BLOG, UPDATE_BLOG } from "../../../redux/blogs/types";
import Loading from "../../../components/isLoading";
import { toast } from "react-toastify";
import BreadCrumps from "../../../components/BreadCrups";
import { fetchBlogData } from "../../../redux/blogs";

export default (props) => {
  const { blogId } = props;
  const dispatch = useDispatch();
  const operationStore = useSelector((store) =>
    blogId ? store.updateBlogGlobalStore : store.createBlogGlobalStore
  );

  const blogData = useSelector((state) => state.blogGlobalStore);

  const [state, setState] = useState({
    openToast: false,
  });

  const openToast = ({ message, type, onClose }) =>
    Toast({ message, type, duration: 3000, onClose });

  useEffect(() => {
    if (blogId && blogId !== blogData.data.id) {
      dispatch(fetchBlogData(blogId));
    }
  }, []);

  const handleFormSubmit = async (formData) => {
    const { title, summary, textContent, imageUrl } = formData;
    const blogInfo = {
      title,
      summary,
      content: textContent,
      imageUrl,
      authorId: "",
    };

    await toast.promise(
      dispatch(
        actionCreator({
          method: blogId ? "PATCH" : "POST",
          path: blogId ? `/api/blogs/${blogId}` : `/api/blogs`,
          actionType: blogId ? UPDATE_BLOG : CREATE_BLOG,
          data: blogInfo,
        })
      ),
      {
        pending: `${!blogId ? "Creating" : "Updating"} Blog`,
      }
    );

    setState({ ...state, openToast: true });
  };
  const navigate = useNavigate();

  if (operationStore.message && state.openToast) {
    Toast({
      message: operationStore.message,
      type: operationStore.message.includes("successful") ? "success" : "error",
      onClose: () =>
        operationStore.message.includes("successful") ? navigate(-1) : null,
    });

    setState({ ...state, openToast: false });
  }
  const crumps = [
    {
      title: "Blogs",
      path: "/blogs-stories",
    },
    {
      title: "New",
    },
  ];

  return (
    <div>
      <BreadCrumps crumps={crumps} />
      {blogId && blogData.loading ? (
        <Loading />
      ) : (
        <div>
          <CreateForm
            isCreate={blogId ? false : true}
            title={`${!blogId ? "Create" : "Update"} Blog`}
            onSubmit={handleFormSubmit}
            openToast={openToast}
            baseBlogData={blogId ? blogData.data : {}}
            isLoading={operationStore.loading}
          />
        </div>
      )}
    </div>
  );
};
